// import { FC, Ref } from 'react';
// import { Form, Formik, FormikProps } from 'formik';
// import { Typography } from 'src/components/common';
// import TextAreaField from 'src/components/common/formFields/textAreaField/TextAreaField';
// import { componentSizeVariantsEnum } from 'src/constants';

// import './editProblemsSolutions.scss';

// import { TIdeaProblemsSolutionsData } from '../../ideaHub.types';
// import { TEditIdeaFormValues } from '../IdeaDetails';
// import { MdExpandLess } from 'react-icons/md';

// export type TEditProblemsSolutionsFormValues = TIdeaProblemsSolutionsData;

// export type TEditProblemsSolutionsProps = TIdeaProblemsSolutionsData & {
//   submitButtonRef: Ref<FormikProps<TEditIdeaFormValues>>;
//   updateFormValues: ({ values }: { values: TEditIdeaFormValues }) => void;
//   handleNext: () => void;
//   goToNextTab: ({ fromEditDetails }: { fromEditDetails: boolean }) => void;
// };

// const EditProblemsSolutions: FC<TEditProblemsSolutionsProps> = ({
//   identifiedProblem,
//   solutionEffectiveness,
//   uniqueValueProposition,
//   submitButtonRef,
//   updateFormValues,
//   handleNext,
//   goToNextTab
// }: TEditProblemsSolutionsProps) => {
//   const initialValues: TEditProblemsSolutionsFormValues = {
//     identifiedProblem,
//     solutionEffectiveness,
//     uniqueValueProposition
//   };

//   const handleSubmit = (values: TEditProblemsSolutionsFormValues) => {
//     updateFormValues({ values });
//     goToNextTab({ fromEditDetails: false });
//   };

//   return (
//     <div className="edit-problems-solutions">
//       <Typography
//         variant="subHeading-2"
//         fontWeight="semiBold"
//         className="edit-idea-edit-details__heading"
//       >
//         Problems & Solutions
//       </Typography>

//       {/* Problems and solutions form */}
//       <Formik
//         initialValues={initialValues}
//         onSubmit={handleSubmit}
//         innerRef={submitButtonRef}
//         enableReinitialize
//       >
//         {({ values, setFieldValue }) => {
//           return (
//             <Form className="edit-problems-solutions__form">
//               {/* Identified Problem */}
//               <TextAreaField
//                 label="Identified Problem"
//                 id="identifiedProblem"
//                 variant={componentSizeVariantsEnum.SMALL}
//                 placeholder="Clearly state and elaborate on the problem your idea aims to address"
//                 onChange={(e) => {
//                   let updatedValue = e.target.value.replace(/\r/g, ''); // Normalize line breaks
//                   if (updatedValue === "") {
//                     console.log("yes");
//                     updatedValue = " ";
//                   }
//                   setFieldValue('identifiedProblem', updatedValue);
//                   updateFormValues({ 
//                     values: { 
//                       ...values, 
//                       identifiedProblem: updatedValue 
//                     } 
//                   });
//                 }}
//                 value={values.identifiedProblem}
//               />

//               {/* Solution Effectiveness */}
//               <TextAreaField
//                 label="Solution Effectiveness"
//                 id="solutionEffectiveness"
//                 variant={componentSizeVariantsEnum.SMALL}
//                 placeholder="Explain how effective your proposed solution is in addressing the identified problem."
//                 onChange={(e) => {
//                   const updatedValue = e.target.value;
//                   setFieldValue('solutionEffectiveness', updatedValue);
//                   updateFormValues({ 
//                     values: { 
//                       ...values, 
//                       solutionEffectiveness: updatedValue 
//                     } 
//                   });
//                 }}
//                 value={values.solutionEffectiveness}
//               />

//               {/* Unique Value Proposition */}
//               <TextAreaField
//                 label="Unique Value Proposition"
//                 id="uniqueValueProposition"
//                 variant={componentSizeVariantsEnum.SMALL}
//                 placeholder="Describe the distinctive value your idea offers"
//                 onChange={(e) => {
//                   const updatedValue = e.target.value;
//                   setFieldValue('uniqueValueProposition', updatedValue);
//                   updateFormValues({ 
//                     values: { 
//                       ...values, 
//                       uniqueValueProposition: updatedValue 
//                     } 
//                   });
//                 }}
//                 value={values.uniqueValueProposition}
//               />
//             </Form>
//           );
//         }}
//       </Formik>
//     </div>
//   );
// };

// EditProblemsSolutions.defaultProps = {
//   identifiedProblem: '',
//   solutionEffectiveness: '',
//   uniqueValueProposition: ''
// };

// export default EditProblemsSolutions;

import { FC, Ref, useState } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import { ConfirmModal, Typography } from 'src/components/common';
import TextAreaField from 'src/components/common/formFields/textAreaField/TextAreaField';
import { componentSizeVariantsEnum } from 'src/constants';

import './editProblemsSolutions.scss';

import { TIdeaProblemsSolutionsData } from '../../ideaHub.types';
import { TEditIdeaFormValues } from '../IdeaDetails';
import { MdExpandLess } from 'react-icons/md';
import { useAppSelector } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';

export type TEditProblemsSolutionsFormValues = TIdeaProblemsSolutionsData;

export type TEditProblemsSolutionsProps = TIdeaProblemsSolutionsData & {
  submitButtonRef: Ref<FormikProps<TEditIdeaFormValues>>;
  updateFormValues: ({ values }: { values: TEditIdeaFormValues }) => void;
  handleNext: () => void;
  goToNextTab: ({ fromEditDetails }: { fromEditDetails: boolean }) => void;
};

const EditProblemsSolutions: FC<TEditProblemsSolutionsProps> = ({
  identifiedProblem,
  solutionEffectiveness,
  uniqueValueProposition,
  submitButtonRef,
  updateFormValues,
  handleNext,
  goToNextTab
}: TEditProblemsSolutionsProps) => {
  const navigate = useNavigate()
  const isAuthorized: boolean = useAppSelector<boolean>((store: any) => store.auth.isAuthorized);
  const initialValues: TEditProblemsSolutionsFormValues = {
    identifiedProblem,
    solutionEffectiveness,
    uniqueValueProposition
  };
  const [show, setShow] = useState<boolean>(false)
  const handleSubmit = (values: TEditProblemsSolutionsFormValues) => {
    updateFormValues({ values });
    goToNextTab({ fromEditDetails: false });
  };
  function handleNavigate() {
    navigate('/login?prev=' + encodeURIComponent('/edit-idea?tab=ideaDetails&editType=newIdea'));
  }

  return (
    <>
      <div className="edit-problems-solutions">
        <Typography
          variant="subHeading-2"
          fontWeight="semiBold"
          className="edit-idea-edit-details__heading"
        >
          Problems & Solutions
        </Typography>

        {/* Problems and solutions form */}
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          innerRef={submitButtonRef}
          enableReinitialize
        >
          {({ values, setFieldValue }) => {
            return (
              <Form className="edit-problems-solutions__form">
                {/* Identified Problem */}
                <TextAreaField
                  label="Identified Problem"
                  id="identifiedProblem"
                  variant={componentSizeVariantsEnum.SMALL}
                  placeholder="Clearly state and elaborate on the problem your idea aims to address"
                  onChange={(e) => {
                    if (!isAuthorized) {
                      setShow(true)
                    }
                    let updatedValue = e.target.value.replace(/\r/g, ''); // Normalize line breaks
                    if (updatedValue === "") {
                      console.log("yes");
                      updatedValue = " ";
                    }
                    setFieldValue('identifiedProblem', updatedValue);
                    updateFormValues({
                      values: {
                        ...values,
                        identifiedProblem: updatedValue
                      }
                    });
                  }}
                  value={values.identifiedProblem}
                />

                {/* Solution Effectiveness */}
                <TextAreaField
                  label="Solution Effectiveness"
                  id="solutionEffectiveness"
                  variant={componentSizeVariantsEnum.SMALL}
                  placeholder="Explain how effective your proposed solution is in addressing the identified problem."
                  onChange={(e) => {
                    if (!isAuthorized) {
                      setShow(true)
                    }
                    const updatedValue = e.target.value;
                    setFieldValue('solutionEffectiveness', updatedValue);
                    updateFormValues({
                      values: {
                        ...values,
                        solutionEffectiveness: updatedValue
                      }
                    });
                  }}
                  value={values.solutionEffectiveness}
                />

                {/* Unique Value Proposition */}
                <TextAreaField
                  label="Unique Value Proposition"
                  id="uniqueValueProposition"
                  variant={componentSizeVariantsEnum.SMALL}
                  placeholder="Describe the distinctive value your idea offers"
                  onChange={(e) => {
                    if (!isAuthorized) {
                      setShow(true)
                      return
                    }
                    const updatedValue = e.target.value;
                    setFieldValue('uniqueValueProposition', updatedValue);
                    updateFormValues({
                      values: {
                        ...values,
                        uniqueValueProposition: updatedValue
                      }
                    });
                  }}
                  value={values.uniqueValueProposition}
                />
              </Form>
            );
          }}
        </Formik>
      </div>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
};

EditProblemsSolutions.defaultProps = {
  identifiedProblem: '',
  solutionEffectiveness: '',
  uniqueValueProposition: ''
};

export default EditProblemsSolutions;
